import { render, staticRenderFns } from "./manage-game.vue?vue&type=template&id=59b14b03&scoped=true&"
import script from "./manage-game.vue?vue&type=script&lang=js&"
export * from "./manage-game.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b14b03",
  null
  
)

export default component.exports